<template>
	<div class="OverallSituation">
		<div class="FBMOrder_top">
			<el-button
				:type="pageCurrent === 'branch' ? 'primary' : ''"
				@click="changePageCurrent('branch')"
			>
				{{ str.management }}
			</el-button>
			<el-button
				:type="pageCurrent === 'son' ? 'primary' : ''"
				@click="changePageCurrent('son')"
				v-if="str.company_id === 1"
			>
				子公司列表
			</el-button>
		</div>
		<div class="choice">
			<el-select
				v-model="branchId"
				placeholder="请选择"
				value-key="id"
				filterable
				v-if="pageCurrent === 'son'"
			>
				<el-option
					v-for="item in branchList"
					:key="item.id"
					:label="item.companyFullName"
					:value="item.id"
				></el-option>
			</el-select>
			<el-input
				v-model="input"
				style="width: 14%;margin-left: 10px;"
				placeholder="公司名称搜索"
			></el-input>
			<el-button
				type="primary"
				class="search"
				style="margin-left: 10px;"
				@click="Search"
				>搜索</el-button
			>
			<el-button
				type="primary"
				class="search"
				style="margin-left: 10px;"
				@click="reset"
				>重置</el-button
			>
			<el-button
				type="primary"
				class="search"
				@click="AddChild"
				v-if="pageCurrent === 'branch'"
				>新增</el-button
			>
		</div>
		<div class="order_list margin-top1">
			<el-table
				border
				:data="tableData"
				v-loading="loading"
				:header-cell-style="{ textAlign: 'center' }"
			>
				<el-table-column
					prop="companyCode"
					label="公司编码"
					width="200"
					align="center"
					sortable
				></el-table-column>
				<el-table-column
					prop="parentCompanyName"
					label="所属分公司"
					min-width="240"
					align="center"
					v-if="pageCurrent === 'son'"
				></el-table-column>
				<el-table-column
					prop="companyFullName"
					label="公司全称"
					min-width="240"
					align="center"
				></el-table-column>
				<el-table-column
					prop="queryTrackSwitch"
					label="快递查询"
					width="100"
					align="center"
					v-if="pageCurrent === 'son'"
				>
					<template slot-scope="scope">
						<span
							style="color: green;"
							v-if="scope.row.queryTrackSwitch === 1"
							>是</span
						>
						<span
							style="color: red;"
							v-else-if="scope.row.queryTrackSwitch === 0"
							>否</span
						>
					</template>
				</el-table-column>
				<el-table-column
					prop="harvestCode"
					label="收货编码"
					width="120"
					align="center"
					v-if="pageCurrent === 'son'"
				></el-table-column>
				<el-table-column
					prop="logisticsQQ"
					label="物流QQ群"
					width="120"
					align="center"
					v-if="pageCurrent === 'son'"
				></el-table-column>
				<el-table-column label="公司余额" width="200" align="center">
					<template slot-scope="scope">
						<p>
							实际余额：
							<span
								:style="{
									color: scope.row.balance <= 0 ? 'red' : '',
								}"
								>{{ scope.row.balance }}</span
							>
						</p>
						<p>
							可用余额：
							<span
								:style="{
									color:
										scope.row.buckleBalance <= 0
											? 'red'
											: '',
								}"
								>{{ scope.row.buckleBalance }}</span
							>
						</p>
					</template>
				</el-table-column>
				<el-table-column
					prop="legalPerson"
					label="法人名称"
					width="120"
					align="center"
				></el-table-column>
				<el-table-column
					prop="scopeOperation"
					label="经营范围"
					width="120"
					align="center"
				></el-table-column>
				<el-table-column
					prop="companyAddress"
					label="办公地址"
					width="240"
					align="center"
				></el-table-column>
				<el-table-column
					prop="telephone"
					label="电话"
					width="120"
					align="center"
				></el-table-column>

				<el-table-column
					prop="updatatime"
					label="修改时间"
					sortable
					width="200"
					align="center"
				></el-table-column>
				<el-table-column
					label="操作"
					fixed="right"
					width="140"
					align="center"
				>
					<template slot-scope="scope">
						<template v-if="pageCurrent === 'branch'">
							<el-button
								type="primary"
								@click="Edit(scope.row)"
								icon="el-icon-edit"
							></el-button>
							<el-button
								type="danger"
								icon="el-icon-delete"
								@click="delbtn(scope.row)"
							></el-button>
						</template>
						<template v-else-if="pageCurrent === 'son'">
							<el-button
								type="primary"
								@click="openCompanyInfo(scope.row)"
								icon="el-icon-edit"
							></el-button>
							<el-button
								type="primary"
								@click="Edit(scope.row)"
								icon="el-icon-view"
							></el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<div class="page">
				<el-pagination
					style="margin-right:200px;"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
		<!-- 新增 -->
		<el-dialog
			title="新增公司"
			top="50px"
			:visible.sync="addedisible"
			width="50%"
		>
			<el-form
				:model="form"
				style="width: 95%;"
				ref="form"
				:rules="dataRule"
			>
				<el-form-item
					label="企业全称"
					:label-width="formLabelWidth"
					prop="fullname1"
				>
					<el-input
						v-model="form.fullname1"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<div style="overflow: hidden;">
					<el-form-item
						label="公司中文简称"
						:label-width="formLabelWidth"
						class="left"
						prop="chinesename1"
					>
						<el-input
							v-model="form.chinesename1"
							autocomplete="off"
						></el-input>
					</el-form-item>
					<el-form-item
						label="公司英文简称"
						:label-width="formLabelWidth"
						class="left"
						prop="englishname1"
					>
						<el-input
							v-model="form.englishname1"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</div>
				<el-form-item
					label="法人名称"
					:label-width="formLabelWidth"
					prop="legalname1"
				>
					<el-input
						v-model="form.legalname1"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item
					label="办公地址"
					:label-width="formLabelWidth"
					prop="address1"
				>
					<el-input
						v-model="form.address1"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item
					label="经营范围"
					:label-width="formLabelWidth"
					prop="range1"
				>
					<el-input
						v-model="form.range1"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item
					label="电话"
					:label-width="formLabelWidth"
					prop="telephone1"
				>
					<el-input v-model="form.telephone1"></el-input>
				</el-form-item>
				<el-form-item
					label="员工数量限制"
					:label-width="formLabelWidth"
					prop="limit1"
				>
					<el-input
						placeholder="请输入内容"
						v-model="form.limit1"
						style="padding: 3px 0;"
					>
						<template slot="append">个</template>
					</el-input>
				</el-form-item>
				<el-form-item
					label="子公司数量限制"
					:label-width="formLabelWidth"
					v-if="str.type === 1"
					prop="childCompanyMax1"
				>
					<el-input
						v-model="form.childCompanyMax1"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<!-- <el-form-item
					label="自用渠道API"
					:label-width="formLabelWidth"
					prop="Radio1"
					v-if="str.type === 2"
				>
					<el-radio-group v-model="form.Radio1">
						<el-radio :label="1">开启</el-radio>
						<el-radio :label="0">关闭</el-radio>
					</el-radio-group>
				</el-form-item> -->

				<!-- <el-form-item
					label="收费方式"
					:label-width="formLabelWidth"
					prop="Radio1"
					v-if="str.type === 2"
				>
					<el-radio-group v-model="form.Radio2">
						<el-radio :label="1">平台费</el-radio>
						<el-radio :label="2">服务费</el-radio>
					</el-radio-group>
				</el-form-item> -->
				<div v-if="str.type === 2">
					<el-form-item
						v-if="NewPlatform1.length"
						label="设置新平台"
						:label-width="formLabelWidth"
					>
						<el-checkbox-group v-model="newPlatform1" @change="handleCheckedCitiesChange($event,'aaa')">
							<el-checkbox
								v-for="(item,index) in NewPlatform1"
								:label="item"
								:key="index"
								>
								<p v-if="item === '1'">Amazon</p>
								<p v-else-if="item === '2'">Shopify</p>
								<p v-else-if="item === '3'">Shopee</p>
								<p v-else-if="item === '4'">Coupang</p>
								<p v-else-if="item === '5'">Shoplazza</p>
								<p v-else-if="item === '6'">Shoplus</p>
								<p v-else-if="item === '7'">Shopline</p>
								<p v-else-if="item === '8'">Ozon</p>
								<p v-else-if="item === '9'">ebay</p>
								<p v-else-if="item === '10'">wish</p>
								<p v-else-if="item === '11'">allegro</p>
								<p v-else-if="item === '12'">TikTok</p>
								<p v-else-if="item === '14'">Aliexpress</p>
								<p v-else-if="item === '15'">Walmart</p>
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<div v-for="(item,index) in plateType" :key="index" class="plateBox" style="margin-bottom: 20px;">
						<el-form-item
							label="平台"
							:label-width="formLabelWidth"
						>
							<!-- <el-input
								v-model="form.platform"
								autocomplete="off"
							></el-input> -->
							<p v-if="item.value === '1'">Amazon</p>
							<p v-else-if="item.value === '2'">Shopify</p>
							<p v-else-if="item.value === '3'">Shopee</p>
							<p v-else-if="item.value === '4'">Coupang</p>
							<p v-else-if="item.value === '5'">Shoplazza</p>
							<p v-else-if="item.value === '6'">Shoplus</p>
							<p v-else-if="item.value === '7'">Shopline</p>
							<p v-else-if="item.value === '8'">Ozon</p>
							<p v-else-if="item.value === '9'">ebay</p>
							<p v-else-if="item.value === '10'">wish</p>
							<p v-else-if="item.value === '11'">allegro</p>
							<p v-else-if="item.value === '12'">TikTok</p>
							<p v-else-if="item.value === '14'">Aliexpress</p>
							<p v-else-if="item.value === '15'">Walmart</p>
						</el-form-item>
						<el-form-item
							label="收费方式"
							:label-width="formLabelWidth"
						>
							<el-radio-group v-model="item.feeType" @change="handleRadio(item)">
								<el-radio :label="1">平台费</el-radio>
								<el-radio :label="2">服务费</el-radio>
							</el-radio-group>
							<!-- <el-radio v-model="key.feeType" :label="key.feeType" v-if="key.feeType == 1">平台费</el-radio>
							<el-radio v-model="key.feeType" :label="key.feeType" v-else-if="key.feeType == 2">服务费</el-radio> -->
						</el-form-item>
						<div v-for="(key,index) in item.plateList" :key="index">
							<el-form-item
								label="平台费用提成"
								:label-width="formLabelWidth"
								v-if="item.feeType == 1 && key.status == 1"
							>
								<el-input
									placeholder="请输入内容"
									v-model="key.extract"
									style="padding: 3px 0;"
								>
									<template slot="append">%</template>
								</el-input>
							</el-form-item>
							<el-form-item
								label="服务费"
								:label-width="formLabelWidth"
								v-if="item.feeType == 2 && key.status == 1"
							>
								<el-table
									:data="key.handleFeeList"
									border
									v-model="key.handleFeeList"
								>
									<el-table-column
										prop="weight"
										label="重量/kg"
										align="center"
									></el-table-column>
									<el-table-column label="基本包材费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.packPrice"
											></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="操作费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.operatingPrice"
											></el-input-number>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</div>
				<div v-else-if="str.type === 1">
					<el-form-item
						v-if="NewPlatform.length"
						label="设置新平台"
						:label-width="formLabelWidth"
					>
						<el-checkbox-group v-model="form.newPlatform" @change="handleCheckedCitiesChange">
							<el-checkbox
								v-for="(item,index) in NewPlatform"
								:label="item"
								:key="index"
								>
								<p v-if="item === '1'">Amazon</p>
								<p v-else-if="item === '2'">Shopify</p>
								<p v-else-if="item === '3'">Shopee</p>
								<p v-else-if="item === '4'">Coupang</p>
								<p v-else-if="item === '5'">Shoplazza</p>
								<p v-else-if="item === '6'">Shoplus</p>
								<p v-else-if="item === '7'">Shopline</p>
								<p v-else-if="item === '8'">Ozon</p>
								<p v-else-if="item === '9'">ebay</p>
								<p v-else-if="item === '10'">wish</p>
								<p v-else-if="item === '11'">allegro</p>
								<p v-else-if="item === '12'">TikTok</p>
								<p v-else-if="item === '14'">Aliexpress</p>
								<p v-else-if="item === '15'">Walmart</p>
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<div v-for="(item,index) in form.plateType" :key="index" class="plateBox" style="margin-bottom: 20px;">
						<el-form-item
							label="平台"
							:label-width="formLabelWidth"
						>
							<p v-if="item.value === '1'">Amazon</p>
							<p v-else-if="item.value === '2'">Shopify</p>
							<p v-else-if="item.value === '3'">Shopee</p>
							<p v-else-if="item.value === '4'">Coupang</p>
							<p v-else-if="item.value === '5'">Shoplazza</p>
							<p v-else-if="item.value === '6'">Shoplus</p>
							<p v-else-if="item.value === '7'">Shopline</p>
							<p v-else-if="item.value === '8'">Ozon</p>
							<p v-else-if="item.value === '9'">ebay</p>
							<p v-else-if="item.value === '10'">wish</p>
							<p v-else-if="item.value === '11'">allegro</p>
							<p v-else-if="item.value === '12'">TikTok</p>
							<p v-else-if="item.value === '14'">Aliexpress</p>
							<p v-else-if="item.value === '15'">Walmart</p>
						</el-form-item>
						<div v-for="(key,index) in item.plateList" :key="index">
							<el-form-item
								label="收费方式"
								:label-width="formLabelWidth"
							>
								<el-radio v-model="key.feeType" :label="key.feeType" v-if="key.feeType == 1">平台费</el-radio>
								<el-radio v-model="key.feeType" :label="key.feeType" v-else-if="key.feeType == 2">服务费</el-radio>
								<!-- <el-radio-group v-model="item.feeType">
									<el-radio :label="1">平台费</el-radio>
									<el-radio :label="2">服务费</el-radio>
								</el-radio-group> -->
							</el-form-item>

							<el-form-item
								label="平台费用提成"
								:label-width="formLabelWidth"
								v-if="key.feeType == 1"
							>
								<el-input
									placeholder="请输入内容"
									v-model="key.extract"
									style="padding: 3px 0;"
								>
									<template slot="append">%</template>
								</el-input>
							</el-form-item>

							<el-form-item
								label="服务费"
								:label-width="formLabelWidth"
								v-if="key.feeType == 2"
							>
								<el-table
									:data="key.handleFeeList"
									border
									v-model="key.handleFeeList"
								>
									<el-table-column
										prop="weight"
										label="重量/kg"
										align="center"
									></el-table-column>
									<el-table-column label="基本包材费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.packPrice"
											></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="操作费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.operatingPrice"
											></el-input-number>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel('form')">取消</el-button>
				<el-button type="primary" :loading="btnAddLoading" @click="Add('form')">确定</el-button>
			</div>
		</el-dialog>
		<!-- 编辑 -->
		<el-dialog
			top="50px"
			title="公司编辑"
			:visible.sync="dialogFormVisible"
			width="50%"
			@close="companyEditDialogClose"
		>
			<el-form :model="form" style="width: 95%;">
				<el-form-item label="公司编码" :label-width="formLabelWidth">
					<span>{{ this.form.companyCode }}</span>
				</el-form-item>
				<el-form-item label="企业全称" :label-width="formLabelWidth">
					<el-input
						v-model="form.fullname"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item
					v-if="
						pageCurrent === 'branch' ||
							(this.userName && this.telephone)
					"
				>
					<div class="body">
						<div class="body-title" v-if="pageCurrent === 'branch'">
							<span>boss分配：</span>
							<span class="associated" @click="associated"
								>关联用户</span
							>
						</div>
						<div
							class="table"
							v-if="this.userName && this.telephone"
						>
							<table
								class="tableData"
								cellpadding="0"
								cellspacing="0"
							>
								<tr>
									<th
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										姓名
									</th>
									<th
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										账号
									</th>
									<th style="width:33%;">操作</th>
								</tr>
								<tr>
									<td
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										{{ this.userName }}
									</td>
									<td
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										{{ this.telephone }}
									</td>
									<td
										style="width:33%;"
										v-if="pageCurrent === 'branch'"
									>
										<el-button type="danger" @click="remove"
											>移除</el-button
										>
									</td>
								</tr>
							</table>
						</div>
					</div>
				</el-form-item>
				<div style="overflow: hidden;">
					<el-form-item
						label="公司中文简称"
						:label-width="formLabelWidth"
						class="left"
					>
						<el-input
							v-model="form.chinesename"
							autocomplete="off"
						></el-input>
					</el-form-item>
					<el-form-item
						label="公司英文简称"
						:label-width="formLabelWidth"
						class="left"
					>
						<el-input
							v-model="form.englishname"
							autocomplete="off"
						></el-input>
					</el-form-item>
				</div>
				<el-form-item label="法人名称" :label-width="formLabelWidth">
					<el-input
						v-model="form.legalname"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item label="办公地址" :label-width="formLabelWidth">
					<el-input
						v-model="form.address"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item label="经营范围" :label-width="formLabelWidth">
					<el-input
						v-model="form.range"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item label="电话" :label-width="formLabelWidth">
					<el-input
						v-model="form.telephone"
						autocomplete="off"
					></el-input>
				</el-form-item>
        <el-form-item label="员工数量限制"
                      :label-width="formLabelWidth">
          <el-input-number v-model="form.limit" :min="0" label="员工数量限制" size="mini">
          </el-input-number>
        </el-form-item>
        <el-form-item label="图片翻译次数"
                      :label-width="formLabelWidth">
          <el-input-number v-model="form.imageTranslationCount" :min="0" label="图片翻译次数" size="mini">
          </el-input-number>
        </el-form-item>
        <el-form-item label="图片白底次数"
                      :label-width="formLabelWidth">
          <el-input-number v-model="form.imageWhiteCount" :min="0" label="图片白底次数" size="mini">

          </el-input-number>
        </el-form-item>
				<el-form-item
					label="子公司数量限制"
					:label-width="formLabelWidth"
					v-if="str.type === 1 && pageCurrent === 'branch'"
					prop="childCompanyMax1"
				>
					<el-input
						v-model="form.childCompanyMax"
						autocomplete="off"
					></el-input>
				</el-form-item>
				<el-form-item
					v-if="NewPlatform.length"
					label="设置新平台"
					:label-width="formLabelWidth"
				>
					<el-checkbox-group v-model="form.newPlatform" @change="handleCheckedCitiesChange">
						<el-checkbox
							v-for="(item,index) in NewPlatform"
							:label="item"
							:key="index"
							>
							<p v-if="item === '1'">Amazon</p>
							<p v-else-if="item === '2'">Shopify</p>
							<p v-else-if="item === '3'">Shopee</p>
							<p v-else-if="item === '4'">Coupang</p>
							<p v-else-if="item === '5'">Shoplazza</p>
							<p v-else-if="item === '6'">Shoplus</p>
							<p v-else-if="item === '7'">Shopline</p>
							<p v-else-if="item === '8'">Ozon</p>
							<p v-else-if="item === '9'">ebay</p>
							<p v-else-if="item === '10'">wish</p>
							<p v-else-if="item === '11'">allegro</p>
							<p v-else-if="item === '12'">TikTok</p>
							<p v-else-if="item === '14'">Aliexpress</p>
							<p v-else-if="item === '15'">Walmart</p>
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<div v-if="str.type === 1 && pageCurrent === 'branch'">
					<div v-for="(item,index) in form.plateType" :key="index" class="plateBox" style="margin-bottom: 20px;">
						<el-form-item
							label="平台"
							:label-width="formLabelWidth"
						>
							<p v-if="item.value === '1'">Amazon</p>
							<p v-else-if="item.value === '2'">Shopify</p>
							<p v-else-if="item.value === '3'">Shopee</p>
							<p v-else-if="item.value === '4'">Coupang</p>
							<p v-else-if="item.value === '5'">Shoplazza</p>
							<p v-else-if="item.value === '6'">Shoplus</p>
							<p v-else-if="item.value === '7'">Shopline</p>
							<p v-else-if="item.value === '8'">Ozon</p>
							<p v-else-if="item.value === '9'">ebay</p>
							<p v-else-if="item.value === '10'">wish</p>
							<p v-else-if="item.value === '11'">allegro</p>
							<p v-else-if="item.value === '12'">TikTok</p>
							<p v-else-if="item.value === '14'">Aliexpress</p>
							<p v-else-if="item.value === '15'">Walmart</p>
						</el-form-item>
						<div v-for="(key,index) in item.plateList" :key="index">
							<el-form-item
								label="收费方式"
								:label-width="formLabelWidth"
							>
								<el-radio v-model="key.feeType" :label="key.feeType" v-if="key.feeType == 1">平台费</el-radio>
								<el-radio v-model="key.feeType" :label="key.feeType" v-else-if="key.feeType == 2">服务费</el-radio>
								<!-- <el-radio-group v-model="item.feeType">
									<el-radio :label="1">平台费</el-radio>
									<el-radio :label="2">服务费</el-radio>
								</el-radio-group> -->
							</el-form-item>

							<el-form-item
								label="平台费用提成"
								:label-width="formLabelWidth"
								v-if="key.feeType == 1"
							>
								<el-input
									placeholder="请输入内容"
									v-model="key.extract"
									style="padding: 3px 0;"
								>
									<template slot="append">%</template>
								</el-input>
							</el-form-item>

							<el-form-item
								label="服务费"
								:label-width="formLabelWidth"
								v-if="key.feeType == 2"
							>
								<el-table
									:data="key.handleFeeList"
									border
									v-model="key.handleFeeList"
								>
									<el-table-column
										prop="weight"
										label="重量/kg"
										align="center"
									></el-table-column>
									<el-table-column label="基本包材费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.packPrice"
											></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="操作费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.operatingPrice"
											></el-input-number>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</div>
				<div v-else>
					<div v-for="(item,index) in form.plateType" :key="index" class="plateBox" style="margin-bottom: 20px;">
						<el-form-item
							label="平台"
							:label-width="formLabelWidth"
						>
							<p v-if="item.value === '1'">Amazon</p>
							<p v-else-if="item.value === '2'">Shopify</p>
							<p v-else-if="item.value === '3'">Shopee</p>
							<p v-else-if="item.value === '4'">Coupang</p>
							<p v-else-if="item.value === '5'">Shoplazza</p>
							<p v-else-if="item.value === '6'">Shoplus</p>
							<p v-else-if="item.value === '7'">Shopline</p>
							<p v-else-if="item.value === '8'">Ozon</p>
							<p v-else-if="item.value === '9'">ebay</p>
							<p v-else-if="item.value === '10'">wish</p>
							<p v-else-if="item.value === '11'">allegro</p>
							<p v-else-if="item.value === '12'">TikTok</p>
							<p v-else-if="item.value === '14'">Aliexpress</p>
							<p v-else-if="item.value === '15'">Walmart</p>
						</el-form-item>
						<el-form-item
							label="收费方式"
							:label-width="formLabelWidth"
						>
							<el-radio-group v-model="item.feeType" @change="handleRadio(item)">
								<el-radio :label="1">平台费</el-radio>
								<el-radio :label="2">服务费</el-radio>
							</el-radio-group>
							<!-- <el-radio v-model="key.feeType" :label="key.feeType" v-if="key.feeType == 1">平台费</el-radio>
							<el-radio v-model="key.feeType" :label="key.feeType" v-else-if="key.feeType == 2">服务费</el-radio> -->
						</el-form-item>
						<div v-for="(key,index) in item.plateList" :key="index">
							<el-form-item
								label="平台费用提成"
								:label-width="formLabelWidth"
								v-if="item.feeType == 1 && key.status == 1"
							>
								<el-input
									placeholder="请输入内容"
									v-model="key.extract"
									style="padding: 3px 0;"
								>
									<template slot="append">%</template>
								</el-input>
							</el-form-item>
							<el-form-item
								label="服务费"
								:label-width="formLabelWidth"
								v-if="item.feeType == 2 && key.status == 1"
							>
								<el-table
									:data="key.handleFeeList"
									border
									v-model="key.handleFeeList"
								>
									<el-table-column
										prop="weight"
										label="重量/kg"
										align="center"
									></el-table-column>
									<el-table-column label="基本包材费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.packPrice"
											></el-input-number>
										</template>
									</el-table-column>
									<el-table-column label="操作费元/件" align="center">
										<template slot-scope="scope">
											<el-input-number
												size="mini"
												v-model="scope.row.operatingPrice"
											></el-input-number>
										</template>
									</el-table-column>
								</el-table>
							</el-form-item>
						</div>
					</div>
				</div>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="CancelEdit">取 消</el-button>
				<el-button
					type="primary"
					:loading="btnEditLoading"
					@click="Editdata"
					v-if="pageCurrent === 'branch'"
					>确 定</el-button
				>
			</div>
		</el-dialog>

		<el-dialog
			title="设置"
			:visible.sync="companyInfoVisible"
			width="40%"
			@close="closeCompanyInfoDialog"
		>
			<el-form
				label-width="120px"
				ref="formCompanyInfo"
				:model="formCompanyInfo"
			>
				<el-form-item label="子公司全称">
					<el-input
						v-model="formCompanyInfo.companyFullName"
						readonly
					></el-input>
				</el-form-item>
				<el-form-item label="中文简称">
					<el-input
						v-model="formCompanyInfo.chineseShortName"
						readonly
					></el-input>
				</el-form-item>
				<el-form-item label="收货编码">
					<el-input
						v-model="formCompanyInfo.partialHarvestCode"
					></el-input>
				</el-form-item>
				<el-form-item label="物流QQ群">
					<el-input v-model="formCompanyInfo.logisticsQQ"></el-input>
				</el-form-item>
				<el-form-item label="快递查询服务">
					<el-radio-group v-model="formCompanyInfo.queryTrackSwitch">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">关闭</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="自用渠道API">
					<el-radio-group
						v-model="formCompanyInfo.selfUseChannelSwitch"
					>
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">关闭</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item
					label="侵权检测"
				>
					<el-radio-group
						v-model="formCompanyInfo.infringementDetection"
					>
						<el-radio :label="0">不开启</el-radio>
						<el-radio :label="1">开启</el-radio>
					</el-radio-group>
				</el-form-item>

        <el-form-item
            label="是否开启clickflare"
        >
          <el-radio-group
              v-model="formCompanyInfo.useClickflare"
          >
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片翻译次数:">
          <el-input-number v-model="formCompanyInfo.imageTranslationCount"  :min="0" label="图片翻译次数" size="mini"></el-input-number>
        </el-form-item>
        <el-form-item label="图片白底次数" >
          <el-input-number v-model="formCompanyInfo.imageWhiteCount" :min="0" label="图片白底次数" size="mini">

          </el-input-number>
        </el-form-item>
				<el-form-item
					v-if="NewPlatform1.length"
					label="设置新平台"
					:label-width="formLabelWidth"
				>
					<el-checkbox-group v-model="newPlatform1" @change="handleCheckedCitiesChange">
						<el-checkbox
							v-for="(item,index) in NewPlatform1"
							:label="item"
							:key="index"
							>
							<p v-if="item === '1'">Amazon</p>
							<p v-else-if="item === '2'">Shopify</p>
							<p v-else-if="item === '3'">Shopee</p>
							<p v-else-if="item === '4'">Coupang</p>
							<p v-else-if="item === '5'">Shoplazza</p>
							<p v-else-if="item === '6'">Shoplus</p>
							<p v-else-if="item === '7'">Shopline</p>
							<p v-else-if="item === '8'">Ozon</p>
							<p v-else-if="item === '9'">ebay</p>
							<p v-else-if="item === '10'">wish</p>
							<p v-else-if="item === '11'">allegro</p>
							<p v-else-if="item === '12'">TikTok</p>
							<p v-else-if="item === '14'">Aliexpress</p>
							<p v-else-if="item === '15'">Walmart</p>
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<div v-for="(item,index) in plateType" :key="index" class="plateBox" style="margin-bottom: 20px;">
					<el-form-item
						label="平台"
						:label-width="formLabelWidth"
					>
						<!-- <el-input
							v-model="form.platform"
							autocomplete="off"
						></el-input> -->
						<p v-if="item.value === '1'">Amazon</p>
						<p v-else-if="item.value === '2'">Shopify</p>
						<p v-else-if="item.value === '3'">Shopee</p>
						<p v-else-if="item.value === '4'">Coupang</p>
						<p v-else-if="item.value === '5'">Shoplazza</p>
						<p v-else-if="item.value === '6'">Shoplus</p>
						<p v-else-if="item.value === '7'">Shopline</p>
						<p v-else-if="item.value === '8'">Ozon</p>
						<p v-else-if="item.value === '9'">ebay</p>
						<p v-else-if="item.value === '10'">wish</p>
						<p v-else-if="item.value === '11'">allegro</p>
						<p v-else-if="item.value === '12'">TikTok</p>
						<p v-else-if="item.value === '14'">Aliexpress</p>
						<p v-else-if="item.value === '15'">Walmart</p>
					</el-form-item>
					<el-form-item
						label="收费方式"
						:label-width="formLabelWidth"
					>
						<el-radio-group v-model="item.feeType" @change="handleRadio(item)">
							<el-radio :label="1">平台费</el-radio>
							<el-radio :label="2">服务费</el-radio>
						</el-radio-group>
						<!-- <el-radio v-model="key.feeType" :label="key.feeType" v-if="key.feeType == 1">平台费</el-radio>
						<el-radio v-model="key.feeType" :label="key.feeType" v-else-if="key.feeType == 2">服务费</el-radio> -->
					</el-form-item>
					<div v-for="(key,index) in item.plateList" :key="index">
						<el-form-item
							label="平台费用提成"
							:label-width="formLabelWidth"
							v-if="item.feeType == 1 && key.status == 1"
						>
							<el-input
								placeholder="请输入内容"
								v-model="key.extract"
								style="padding: 3px 0;"
							>
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
						<el-form-item
							label="服务费"
							:label-width="formLabelWidth"
							v-if="item.feeType == 2 && key.status == 1"
						>
							<el-table
								:data="key.handleFeeList"
								border
								v-model="key.handleFeeList"
							>
								<el-table-column
									prop="weight"
									label="重量/kg"
									align="center"
								></el-table-column>
								<el-table-column label="基本包材费元/件" align="center">
									<template slot-scope="scope">
										<el-input-number
											size="mini"
											v-model="scope.row.packPrice"
										></el-input-number>
									</template>
								</el-table-column>
								<el-table-column label="操作费元/件" align="center">
									<template slot-scope="scope">
										<el-input-number
											size="mini"
											v-model="scope.row.operatingPrice"
										></el-input-number>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</div>
				</div>
			</el-form>
			<el-row slot="footer">
				<el-button @click="companyInfoVisible = false">取 消</el-button>
				<el-button
					type="primary"
					@click="setCompanyInfo"
					:loading="companyInfoLoading"
					>完 成</el-button
				>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../api/api/api'
import {
	validateMobiePhone,
	validateEnglish,
	validateChinese,
	validateUpperEnglish,
} from '../../utils/validate'
export default {
	name: 'OverallSituation',
	data() {
		var validateMobile = (rule, value, callback) => {
			if (!validateMobiePhone(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		var validatecompanyEnglish = (rule, value, callback) => {
			if (!validateUpperEnglish(value)) {
				callback(new Error('公司英文简称格式错误：只能输入大写英文'))
			} else {
				callback()
			}
		}
		var validatecompanyChinese = (rule, value, callback) => {
			if (!validateChinese(value)) {
				callback(new Error('公司中文简称格式错误：只能输入中文+数字'))
			} else {
				callback()
			}
		}
		let validateNumber = (rule, value, callback) => {
			if (!/^\d+$/g.test(value)) {
				callback(new Error('请输入正确的数字'))
			} else {
				callback()
			}
		}
		return {
			dataRule: {
				telephone1: [
					{
						required: true,
						message: '手机号不能为空',
						trigger: 'blur',
					},
					{ validator: validateMobile, trigger: 'blur' },
				],
				fullname1: [
					{
						required: true,
						message: '企业全称不能为空',
						trigger: 'blur',
					},
				],
				chinesename1: [
					{
						required: true,
						message: '公司中文简称不能为空',
						trigger: 'blur',
					},
					{ validator: validatecompanyChinese, trigger: 'blur' },
				],
				englishname1: [
					{
						required: true,
						message: '公司英文简称不能为空',
						trigger: 'blur',
					},
					{ validator: validatecompanyEnglish, trigger: 'blur' },
				],
				legalname1: [
					{
						required: true,
						message: '法人名称不能为空',
						trigger: 'blur',
					},
				],
				address1: [
					{
						required: true,
						message: '办公地址不能为空',
						trigger: 'blur',
					},
				],
				range1: [
					{
						required: true,
						message: '经营范围不能为空',
						trigger: 'blur',
					},
				],
				royalty1: [
					{
						required: true,
						message: '平台费用提成不能为空',
						trigger: 'blur',
					},
				],
				limit1: [
					{
						required: true,
						message: '员工数量限制不能为空',
						trigger: 'blur',
					},
				],
				childCompanyMax1: [
					{
						required: true,
						message: '子公司数量限制不能为空',
						trigger: 'blur',
					},
				],
				Radio1: [
					{
						required: true,
						message: '请选择开启/关闭自用渠道API',
						trigger: 'blur',
					},
				],
			},
			total: 0,
			currentpage: 1,
			pagesize: 10,
			size: 10,
			str: '',
			input: '',
			dialogFormVisible: false,
			addedisible: false,
			currentPage: 1,
			rid: '',
			system: '',
			telephone: '',
			userName: '',
			boss: '',
			tableData: [],
			loading: true,
			serviceFee: [],
			TableFree: [],
			form: {
				id: '',
				fullname: '',
				chinesename: '',
				englishname: '',
				legalname: '',
				address: '',
				range: '',
				telephone: '',
				royalty: '',
				limit: '',
        imageTranslationCount: '',
        imageWhiteCount: '',
				childCompanyMax: '',
				Radios: '',

				serviceFee1: [],
				plateType: [],
				newPlatform: [],
				fullname1: '',
				chinesename1: '',
				englishname1: '',
				legalname1: '',
				address1: '',
				range1: '',
				telephone1: '',
				royalty1: '',
				limit1: '',
				childCompanyMax1: '',
				Radio1: 0,
				Radio2: 1,
			},
			formLabelWidth: '130px',
			Edittype: '',
			pid: '',
			pageCurrent: 'branch',
			branchId: '',
			branchList: [],

			companyInfoVisible: false,
			companyInfoLoading: false,
			formCompanyInfo: {
				chineseShortName: '',
				partialHarvestCode: '',
				logisticsQQ: '',
				queryTrackSwitch: 0,
				feeType: 1,
				handleFees: [],
				selfUseChannelSwitch: 0,
        useClickflare:0,
        imageTranslationCount:'',
        imageWhiteCount:'',
				extract: '',
				infringementDetection: '',
				childCompanyMax: '',
				companyAddress: '',
				companyMemberMax: '',
				englishShortName: '',
				id: '',
				legalPerson: '',
				pid: '',
				scopeOperation: '',
				telephone: '',
				type: ''
			},
			FreeShow: '',
			FreeShow1: '',
			NewPlatform: [],
			NewPlatform1: [],
			plateList1: [],
			plateList2: [],
			newPlatform1: [],
			plateType: [],
			btnEditLoading: false,
			btnAddLoading: false
		}
	},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.DataList()
		this.getBranchCompanyList()
	},
	methods: {
		handleRadio(value) {
			value.plateList.forEach(item => {
				if(item.feeType === value.feeType) {
					item.status = 1
				}else{
					item.status = 0
				}
			})
		},
		handleCheckedCitiesChange(value,key) {
			ajaxPost(Baseurl + 'handleFeeController/getDefultWeights').then(
				(res) => {
					if (res.data.code === 200) {
						const arr = value.map((item => ({
							value: item,
							plateList: [{
								feeType: 1,
								extract: 3,
								status: 1,
								handleFeeList: null,
								sellerType: Number(item),
								companyId: this.str.company_id
							},{
								feeType: 2,
								extract: null,
								handleFeeList: res.data.data,
								status: 0,
								sellerType: Number(item),
								companyId: this.str.company_id
							}],
							feeType: 1
						})))
						arr.forEach(item => {
							item.plateList.forEach(key => {
								if(key.handleFeeList != null) {
									key.handleFeeList.forEach(val => {
										val.weightId = val.id;
										val.id = null
									})
								}
							})
						})
						if(this.pageCurrent === 'branch') {
							this.form.plateType = this.plateList1.concat(arr)
							//console.log(this.form.plateType)
						}else{
							this.plateType = this.plateList2.concat(arr)
							//console.log(this.plateType)
						}
						if(key) {
							this.plateType = this.plateList2.concat(arr)
							//console.log(this.plateType)
						}
					}
				}
			)
		},
		DataList() {
			var obj = {
				id: this.str.company_id,
				page: this.currentPage,
				size: this.size,
			}
			this.loading = true
			ajaxPost(
				Baseurl + 'companyController/selectCompanyChildByCompanyId',
				obj
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.loading = false
					this.tableData = data.list.sort((a, b) => a.id - b.id)
					this.total = data.total
				}
			})
		},
		AddChild() {
			if (this.str.type === 2) {
				var obj = {
					id: this.str.company_id,
					type: this.str.type,
					childCompanyMax: this.str.company.childCompanyMax,
				}
				ajaxPost(
					Baseurl + 'companyController/isLimitReachedOfChildCompany',
					obj
				).then((res) => {
					if (res.data.code === 500) {
						this.$message.error(res.data.data)
					} else if (res.data.code === 200) {
						this.addedisible = true
						if(this.str.type === 2) {
							this.newPlatform1 = []
							this.plateType = []
							this.plateList2 = []
							this.NewPlatform1 = this.str.company.plateType.split(',')
						}else if(this.str.type === 1){
							this.plateList1 = []
							this.form.newPlatform = []
							this.form.plateType = []
							this.NewPlatform = this.str.company.plateType.split(',')
						}
					}
				})
				this.serviceFeeList()
			} else if (this.str.type === 1) {
				this.addedisible = true
				this.serviceFeeList()
				if(this.str.type === 2) {
					this.newPlatform1 = []
					this.plateType = []
					this.plateList2 = []
					this.NewPlatform1 = this.str.company.plateType.split(',')
				}else if(this.str.type === 1){
					this.plateList1 = []
					this.form.newPlatform = []
					this.form.plateType = []
					this.NewPlatform = this.str.company.plateType.split(',')
				}
			}
		},
		serviceFeeList() {
			ajaxPost(Baseurl + 'handleFeeController/getDefultWeights').then(
				(res) => {
					if (res.data.code === 200) {
						this.serviceFee = res.data.data
					}
				}
			)
		},
		Edit(val) {
			this.dialogFormVisible = true
			this.form.id = val.id
			this.form.fullname = val.companyFullName
			this.form.chinesename = val.chineseShortName
			this.form.englishname = val.englishShortName
			this.form.legalname = val.legalPerson
			this.form.address = val.companyAddress
			this.form.range = val.scopeOperation
			this.form.telephone = val.telephone
			this.form.royalty = val.extract
			this.form.limit = val.companyMemberMax
      this.form.imageTranslationCount = val.imageTranslationCount
      this.form.imageWhiteCount = val.imageWhiteCount
			this.form.childCompanyMax = val.childCompanyMax
			this.form.companyCode = val.companyCode
			this.form.Radios = val.selfUseChannelSwitch
			this.form.serviceFee1 = val.handleFees
			if(val.faCompanyPlateType) {
				this.NewPlatform = val.faCompanyPlateType.split(',')
			}
			const arr = val.plateType.split(',')
			this.form.plateType = arr.map(item => ({value: item}))
			var list1 = [];
			var list2 = [];
			var list3 = [];
			var list4 = [];
			var list5 = [];
			var list6 = [];
			var list7 = [];
			var list8 = [];
			var list9 = [];
			var list10 = [];
			var list11 = [];
			var list12 = [];
			var list14 = [];
			var list15 = [];
			val.companyPlateFeeList.forEach(item => {
				if(item.sellerType == 1) {
					list1.push(item)
				}else if(item.sellerType == 2) {
					list2.push(item)
				}else if(item.sellerType == 3) {
					list3.push(item)
				}else if(item.sellerType == 4) {
					list4.push(item)
				}else if(item.sellerType == 5) {
					list5.push(item)
				}else if(item.sellerType == 6) {
					list6.push(item)
				}else if(item.sellerType == 7) {
					list7.push(item)
				}else if(item.sellerType == 8) {
					list8.push(item)
				}else if(item.sellerType == 9) {
					list9.push(item)
				}else if(item.sellerType == 10) {
					list10.push(item)
				}else if(item.sellerType == 11) {
					list11.push(item)
				}else if(item.sellerType == 12) {
					list12.push(item)
				}else if(item.sellerType == 14) {
					list14.push(item)
				}else if(item.sellerType == 15) {
					list15.push(item)
				}
			})
			this.form.plateType.forEach(item => {
				if(item.value == '1'){
					item['plateList'] = list1
				}else if(item.value == '2'){
					item['plateList'] = list2
				}else if(item.value == '3'){
					item['plateList'] = list3
				}else if(item.value == '4'){
					item['plateList'] = list4
				}else if(item.value == '5'){
					item['plateList'] = list5
				}else if(item.value == '6'){
					item['plateList'] = list6
				}else if(item.value == '7'){
					item['plateList'] = list7
				}else if(item.value == '8'){
					item['plateList'] = list8
				}else if(item.value == '9'){
					item['plateList'] = list9
				}else if(item.value == '10'){
					item['plateList'] = list10
				}else if(item.value == '11'){
					item['plateList'] = list11
				}else if(item.value == '12'){
					item['plateList'] = list12
				}else if(item.value == '14'){
					item['plateList'] = list14
				}else if(item.value == '15'){
					item['plateList'] = list15
				}
			})
			this.form.plateType.forEach(item => {
				item.plateList.forEach(key => {
					if(key.status == 1) {
						this.$set(item, 'feeType', key.feeType)
					}
				})
			})
			this.plateList1 = this.form.plateType
			this.boss = val.boss
			this.Edittype = val.type
			this.pid = val.pid
			if (this.boss != null) {
				this.rid = val.boss.rid
				this.userName = val.boss.userName
				this.telephone = val.boss.telephone
				this.system = val.boss.system
			}
			if (val.feeType == 1) {
				this.FreeShow = true
				this.FreeShow1 = false
			} else if (val.feeType == 2) {
				this.FreeShow = false
				this.FreeShow1 = true
			}
		},
		Editdata() {
			const plateTypeList = this.form.plateType.map(item => {
				return item.value
			})
			let companyPlateFeeList = [];
			this.form.plateType.forEach(item => {
				item.plateList.forEach(key => {
					companyPlateFeeList.push(key)
				})
			})
			var obj = {
				childCompanyMax: this.form.childCompanyMax,
				chineseShortName: this.form.chinesename,
				companyAddress: this.form.address,
				companyFullName: this.form.fullname,
				companyMemberMax: this.form.limit,
        imageTranslationCount: this.form.imageTranslationCount,
        imageWhiteCount: this.form.imageWhiteCount,
				englishShortName: this.form.englishname,
				extract: this.form.royalty,
				id: this.form.id,
				legalPerson: this.form.legalname,
				pid: this.pid,
				scopeOperation: this.form.range,
				selfUseChannelSwitch: this.form.Radios,
				telephone: this.form.telephone,
				type: this.Edittype,
				plateTypeList: plateTypeList,
				companyPlateFeeList: companyPlateFeeList

			}
			this.btnEditLoading = true
			ajaxPost(
				Baseurl + 'companyController/updateCompanyByCompanyId',
				obj
			).then((res) => {
				this.btnEditLoading = false
				if (res.data.code === 200) {
					this.$message({
						type: 'success',
						message: '修改公司信息成功',
					})
					this.dialogFormVisible = false
					this.DataList()
				} else {
					this.$message.error(res.data.data)
				}
			}).catch(() => {this.btnAddLoading = false})
		},
		CancelEdit() {
			this.dialogFormVisible = false
		},
		Add(form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
					if(this.str.type === 2) {
						if(this.newPlatform1.length == 0) {
							this.$message.warning('请至少选择一个新平台')
						}else{
							this.submit()
						}
					}else if(this.str.type === 1) {
						if(this.form.newPlatform.length == 0) {
							this.$message.warning('请至少选择一个新平台')
						}else{
							this.submit()
						}
					}
				} else {
					return false
				}
			})
		},
		submit() {
			var plateTypeList = [];
			var companyPlateFeeList = [];
			if(this.str.type === 1) {
				plateTypeList = this.form.plateType.map(item => {
					return item.value
				})
				this.form.plateType.forEach(item => {
					item.plateList.forEach(key => {
						companyPlateFeeList.push(key)
					})
				})
			}else if(this.str.type === 2) {
				plateTypeList = this.plateType.map(item => {
					return item.value
				})
				this.plateType.forEach(item => {
					item.plateList.forEach(key => {
						companyPlateFeeList.push(key)
					})
				})
			}
			var obj = {
				companyFullName: this.form.fullname1,
				chineseShortName: this.form.chinesename1,
				englishShortName: this.form.englishname1,
				legalPerson: this.form.legalname1,
				companyAddress: this.form.address1,
				scopeOperation: this.form.range1,
				telephone: this.form.telephone1,
				extract: this.form.royalty1,
				companyMemberMax: this.form.limit1,
				selfUseChannelSwitch: this.form.Radios,
				pid: this.str.company_id,
				type: this.str.type,
				childCompanyMax: this.form.childCompanyMax1,
				weightPojos: this.serviceFee,
				feeType: this.form.Radio2,
				plateTypeList: plateTypeList,
				companyPlateFeeList: companyPlateFeeList
			}
			this.btnAddLoading = true
			ajaxPost(
				Baseurl + 'companyController/insertCompany',
				obj
			).then((res) => {
				this.btnAddLoading = false
				if (res.data.code === 200) {
					this.$message({
						type: 'success',
						message: '新增公司信息成功',
					})
					this.DataList()
					this.addedisible = false
					this.form.fullname1 = ''
					this.form.chinesename1 = ''
					this.form.englishname1 = ''
					this.form.legalname1 = ''
					this.form.address1 = ''
					this.form.range1 = ''
					this.form.telephone1 = ''
					this.form.royalty1 = ''
					this.form.limit1 = ''
					this.form.childCompanyMax1 = ''
				} else {
					this.$message.error(res.data.data)
				}
			}).catch(() => {this.btnAddLoading = false})
		},
		cancel(form) {
			this.addedisible = false
			this.$refs[form].resetFields()
		},
		remove() {
			this.$confirm(
				'该操作将删除当前角色（组/分部门）的全部数据，是否继续',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					var obj = { rid: this.rid, system: this.system }
					ajaxPost(
						Baseurl + 'roleController/cancelRelationUser',
						obj
					).then((res) => {
						if (res.data.code === 200) {
							this.$message({
								type: 'success',
								message: '移除用户成功',
							})
							this.userName = res.data.data.userName
							this.telephone = res.data.data.telephone
							this.DataList()
						} else {
							this.$message.error('移除用户失败')
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消移除',
					})
				})
		},
		associated() {
			this.$prompt('账号', '关联用户', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			})
				.then(({ value }) => {
					if (value === '') {
						this.$message.error('账号不能为空')
					} else {
						var obj = {
							rid: this.rid,
							telephone: value,
						}
						ajaxPost(
							Baseurl + 'roleController/relationUser',
							obj
						).then((res) => {
							if (res.data.code === 200) {
								this.$message({
									type: 'success',
									message: '关联用户成功',
								})
								this.userName = res.data.data.userName
								this.telephone = res.data.data.telephone
								this.DataList()
							} else {
								this.$message.error(res.data.data)
							}
						})
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入',
					})
				})
		},
		delbtn(val) {
			this.$confirm('确认删除当前公司信息？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var obj = {
						id: val.id,
					}
					ajaxPost(
						Baseurl + 'companyController/deleteCompanyByCompanyId',
						obj
					).then((res) => {
						if (res.data.code === 200) {
							this.$message({
								type: 'success',
								message: '删除成功',
							})
							this.DataList()
						} else {
							this.$message.error(res.data.data)
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		Search() {
			if (this.pageCurrent === 'branch') {
				var obj = {
					companyFullName: this.input,
					pid: this.str.company_id,
					signRid: this.str.rid,
				}
				this.loading = true
				ajaxPost(
					Baseurl + 'companyController/selectCompanyByCompanyName',
					obj
				).then((res) => {
					if (res.data.code === 200) {
						this.loading = false
						this.tableData = res.data.data
					}
				})
			} else if (this.pageCurrent === 'son') {
				this.currentPage = 1
				this.getSonCompanyList()
			}
		},
		handleSizeChange(val) {
			this.size = val
			if (this.pageCurrent === 'branch') {
				var roleId = {
					page: this.currentPage,
					size: this.size,
					id: this.str.company_id,
				}
				this.loading = true
				ajaxPost(
					Baseurl + 'companyController/selectCompanyChildByCompanyId',
					roleId
				).then((res) => {
					this.loading = false
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			} else if (this.pageCurrent === 'son') {
				this.getSonCompanyList()
			}
		},
		handleCurrentChange(val) {
			this.currentPage = val
			if (this.pageCurrent === 'branch') {
				var roleId = {
					page: this.currentPage,
					size: this.size,
					id: this.str.company_id,
				}
				this.loading = true
				ajaxPost(
					Baseurl + 'companyController/selectCompanyChildByCompanyId',
					roleId
				).then((res) => {
					this.loading = false
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			} else if (this.pageCurrent === 'son') {
				this.getSonCompanyList()
			}
		},
		getSonCompanyList() {
			const API = Baseurl + 'companyController/selectAllSubsidiaryCompany'
			const paramsData = {
				page: this.currentPage,
				size: this.size,
				companyFullName: this.input,
				pid: this.branchId,
			}
			this.loading = true
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.loading = false
					this.total = data.total
					this.tableData = data.list
				}
			})
		},
		getBranchCompanyList() {
			const API =
				Baseurl + 'companyController/selectChildCompanyByCompanyId'
			const paramsData = {
				id: this.str.company_id,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.branchList = data
				}
			})
		},
		changePageCurrent(type) {
			this.currentPage = 1
			this.size = 10
			this.pageCurrent = type
			this.tableData = []
			if (this.pageCurrent === 'branch') {
				this.DataList()
			} else if (this.pageCurrent === 'son') {
				this.getSonCompanyList()
			}
		},
		companyEditDialogClose() {
			this.dialogFormVisible = false
			this.form.id = ''
			this.form.fullname = ''
			this.form.chinesename = ''
			this.form.englishname = ''
			this.form.legalname = ''
			this.form.address = ''
			this.form.range = ''
			this.form.telephone = ''
			this.form.royalty = ''
			this.form.limit = ''
      this.form.imageTranslationCount = ''
      this.form.imageWhiteCount = ''
			this.form.childCompanyMax = ''
			this.form.companyCode = ''
			this.form.plateType = []
			this.form.newPlatform = []
			this.NewPlatform = []
			this.plateList1 = []
			this.plateList2 = []
			this.boss = ''
			this.Edittype = ''
			this.pid = ''
			this.userName = ''
			this.telephone = ''
		},
		openCompanyInfo(row) {
			this.companyInfoVisible = true
			const {
				companyFullName,
				chineseShortName,
				id,
				logisticsQQ = '',
				partialHarvestCode = '',
				queryTrackSwitch = 0,
        useClickflare,
        imageTranslationCount,
        imageWhiteCount,
				feeType,
				handleFees,
				selfUseChannelSwitch,
				extract,
				infringementDetection,
				childCompanyMax,
				companyAddress,
				companyMemberMax,
				englishShortName,
				legalPerson,
				pid,
				scopeOperation,
				telephone,
				type
			} = row
			this.formCompanyInfo = {
				companyFullName,
				chineseShortName,
				id,
				logisticsQQ,
				partialHarvestCode,
				queryTrackSwitch,
        useClickflare,
        imageTranslationCount,
        imageWhiteCount,
				feeType,
				handleFees,
				selfUseChannelSwitch,
				extract,
				infringementDetection,
				childCompanyMax,
				companyAddress,
				companyMemberMax,
				englishShortName,
				legalPerson,
				pid,
				scopeOperation,
				telephone,
				type
			}
			if(row.faCompanyPlateType) {
				this.NewPlatform1 = row.faCompanyPlateType.split(',')
			}
			const arr = row.plateType.split(',')
			this.plateType = arr.map(item => ({value: item}))
			var list1 = [];
			var list2 = [];
			var list3 = [];
			var list4 = [];
			var list5 = [];
			var list6 = [];
			var list7 = [];
			var list8 = [];
			var list9 = [];
			var list10 = [];
			var list11 = [];
			var list12 = [];
			var list14 = [];
			var list15 = [];
			row.companyPlateFeeList.forEach(item => {
				if(item.sellerType == 1) {
					list1.push(item)
				}else if(item.sellerType == 2) {
					list2.push(item)
				}else if(item.sellerType == 3) {
					list3.push(item)
				}else if(item.sellerType == 4) {
					list4.push(item)
				}else if(item.sellerType == 5) {
					list5.push(item)
				}else if(item.sellerType == 6) {
					list6.push(item)
				}else if(item.sellerType == 7) {
					list7.push(item)
				}else if(item.sellerType == 8) {
					list8.push(item)
				}else if(item.sellerType == 9) {
					list9.push(item)
				}else if(item.sellerType == 10) {
					list10.push(item)
				}else if(item.sellerType == 11) {
					list11.push(item)
				}else if(item.sellerType == 12) {
					list12.push(item)
				}else if(item.sellerType == 14) {
					list14.push(item)
				}else if(item.sellerType == 15) {
					list15.push(item)
				}
			})
			this.plateType.forEach(item => {
				if(item.value == '1'){
					item['plateList'] = list1
				}else if(item.value == '2'){
					item['plateList'] = list2
				}else if(item.value == '3'){
					item['plateList'] = list3
				}else if(item.value == '4'){
					item['plateList'] = list4
				}else if(item.value == '5'){
					item['plateList'] = list5
				}else if(item.value == '6'){
					item['plateList'] = list6
				}else if(item.value == '7'){
					item['plateList'] = list7
				}else if(item.value == '8'){
					item['plateList'] = list8
				}else if(item.value == '9'){
					item['plateList'] = list9
				}else if(item.value == '10'){
					item['plateList'] = list10
				}else if(item.value == '11'){
					item['plateList'] = list11
				}else if(item.value == '12'){
					item['plateList'] = list12
				}else if(item.value == '14'){
					item['plateList'] = list14
				}else if(item.value == '15'){
					item['plateList'] = list15
				}
			})
			this.plateType.forEach(item => {
				item.plateList.forEach(key => {
					if(key.status == 1) {
						this.$set(item, 'feeType', key.feeType)
					}
				})
			})
			this.plateList2 = this.plateType
		},
		setCompanyInfo() {
			this.$refs.formCompanyInfo.validate((valid) => {
				if (!valid) return
				const plateTypeList = this.plateType.map(item => {
					return item.value
				})
				let companyPlateFeeList = [];
				this.plateType.forEach(item => {
					item.plateList.forEach(key => {
						companyPlateFeeList.push(key)
					})
				})
				const API =
					Baseurl +
					'companyController/updateCompanyByCompanyId'
				const paramsData = {
					childCompanyMax: this.formCompanyInfo.childCompanyMax,
					companyAddress: this.formCompanyInfo.companyAddress,
					companyMemberMax: this.formCompanyInfo.companyMemberMax,
					englishShortName: this.formCompanyInfo.englishShortName,
					extract: this.formCompanyInfo.extract,
					id: this.formCompanyInfo.id,
					legalPerson: this.formCompanyInfo.legalPerson,
					pid: this.formCompanyInfo.pid,
					scopeOperation: this.formCompanyInfo.scopeOperation,
					telephone: this.formCompanyInfo.telephone,
					type: this.formCompanyInfo.type,
					companyFullName: this.formCompanyInfo.companyFullName,
					chineseShortName: this.formCompanyInfo.chineseShortName,
					partialHarvestCode: this.formCompanyInfo.partialHarvestCode,
					logisticsQQ: this.formCompanyInfo.logisticsQQ,
					queryTrackSwitch: this.formCompanyInfo.queryTrackSwitch,
					selfUseChannelSwitch: this.formCompanyInfo.selfUseChannelSwitch,
          useClickflare: this.formCompanyInfo.useClickflare,
          imageTranslationCount: this.formCompanyInfo.imageTranslationCount,
          imageWhiteCount: this.formCompanyInfo.imageWhiteCount,
					infringementDetection: this.formCompanyInfo.infringementDetection,
					plateTypeList: plateTypeList,
					companyPlateFeeList: companyPlateFeeList
				}
				this.companyInfoLoading = true
				ajaxPost(API, paramsData).then((res) => {
					this.companyInfoLoading = false
					if (res.data.code === 200) {
						this.$message.success('操作成功！')
						this.companyInfoVisible = false
					} else {
						this.$message.error(res.data.data)
					}
				})
			})
		},
		closeCompanyInfoDialog() {
			this.formCompanyInfo = {
				partialHarvestCode: '',
				logisticsQQ: '',
				chineseShortName: '',
				queryTrackSwitch: 0,
				feeType: this.formCompanyInfo.feeType,
				extract: this.formCompanyInfo.extract,
				infringementDetection: this.formCompanyInfo
					.infringementDetection,
				plateType: []
			}
			this.newPlatform1 = []
			this.NewPlatform1 = []
			this.plateList1 = []
			this.plateList2 = []
			this.getSonCompanyList()
		},
		reset() {
			this.input = ''
			this.branchId = ''
			this.getSonCompanyList()
		},
	},
}
</script>

<style lang="scss">
.OverallSituation {
	width: 98%;
	position: relative;
	padding-bottom: 50px;
	.el-form-item__label {
		text-align: center;
	}
	.choice {
		margin-top: 1%;
		overflow: hidden;
	}
	.el-dialog {
		width: 35%;
	}
	.el-dialog__body {
		padding: 10px 20px;
	}
	.el-form-item {
		margin-bottom: 18px;
	}
	.left {
		float: left;
		width: 50%;
	}
	.el-input-group {
		padding: 10px;
	}
	.plateBox {
		border: 1px solid #cbced3;
		padding: 15px;
	}
	.body {
		border: 1px solid #e4e7ed;
		padding: 15px;
		margin-bottom: 20px;
	}
	.body-title {
		line-height: 20px;
		padding: 10px;
		border-bottom: 1px solid #e4e7ed;
	}
	.table {
		margin-top: 30px;
	}
	.table table {
		width: 100%;
		height: 100px;
		text-align: center;
		border: 1px solid #ebeef5;
	}
	.table td {
		color: #606266;
	}
	.table th {
		border-bottom: 1px solid #ebeef5;
		color: #909399;
	}
	.associated {
		cursor: pointer;
		color: #409eff;
	}
	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
	}
}
</style>
